__turbopack_context__.v({
  "tooltip": "AccountLink-module__FfCRea__tooltip",
});
